import type {
  Ability,
  CharacterStats,
  MovementStats,
} from '../../CharacterTypes';

export const WARRIOR_CONFIG = {
  name: 'Steadfast',
  description: 'Front-line fighter with high health and melee damage',
  baseStats: {
    strength: 15,
    dexterity: 10,
    intelligence: 8,
    luck: 7,
    attack: 12,
    magicAttack: 0,
    defense: 10,
    magicDefense: 10,
    criticalRate: 0.05
  } as CharacterStats,
  healthMultiplier: 1.2,
  manaMultiplier: 0.7,
  color: '#8B4513',
  movementStats: {
    jumpPower: 1200,
    targetJumpHeight: 200,
    moveSpeed: 340,
    gravityScale: 1.0,
    terminalVelocity: 1000,
    acceleration: 3500,
    deceleration: 6000
  } as MovementStats,
  abilities: [
    {
      id: 'warrior_auto',
      name: 'Slash',
      damage: 12,
      manaCost: 0,
      cooldown: 600,
      lastUsed: 0,
      range: 80,
      castTime: 0,
      description: 'Basic melee strike.',
      icon: '/icons/basic_strike.svg'
    },
    {
      id: 'basic_strike',
      name: 'Slash',
      damage: 15,
      manaCost: 0,
      cooldown: 500,
      lastUsed: 0,
      range: 80,
      castTime: 0,
      description: 'Quick melee strike',
      icon: '/icons/basic_strike.svg'
    },
    {
      id: 'sword_throw',
      name: 'Sword Throw',
      damage: 20,
      manaCost: 15,
      cooldown: 3000,
      lastUsed: 0,
      range: 600,
      castTime: 0,
      description: 'Throw a spinning sword at the enemy',
      icon: '/icons/sword_throw.svg'
    },
    {
      id: 'defensive_stance',
      name: 'Defensive Stance',
      damage: 0,
      manaCost: 15,
      cooldown: 15000,
      lastUsed: 0,
      range: 0,
      castTime: 0,
      description: 'Increase defense by 50% for 10 seconds',
      icon: '/icons/defensive_stance.svg'
    },
    {
      id: 'battle_cry',
      name: 'Battle Cry',
      damage: 0,
      manaCost: 20,
      cooldown: 20000,
      lastUsed: 0,
      range: 200,
      castTime: 0,
      description: 'Increase damage for 30 seconds',
      icon: '/icons/battle_cry.svg'
    }
  ] as Ability[]
};
